/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/Manual/AppRegistrationManualComponent" />
import * as React from "react";

import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";

import { StoreManager } from "DistributedTask/Flux/StoreManager";
import { ActionsCreatorInstanceIds } from "DistributedTaskUI/ServiceEndpoints/Editor/Constants";
import { CredentialTypeStore, ICredentialTypeState } from "DistributedTaskUI/ServiceEndpoints/Editor/Stores/CredentialTypeStore";
import { ServiceEndpoint } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";
import { ArmCredentialsType } from "../AzureRMCredentialsTypeSelector";
import { ManualSecretComponent } from "./ManualSecretComponent";
import { ManualWIFComponent } from "./ManualWIFComponent";

export class AppRegistrationManualComponent extends VssComponent<{}, ICredentialTypeState> {

    private readonly _store: CredentialTypeStore;

    constructor(props: {endpoint: ServiceEndpoint}, context: IVssComponentContext) {
        super(props, context);

        this._store = StoreManager.GetStore<CredentialTypeStore>(CredentialTypeStore, ActionsCreatorInstanceIds.CredentialTypeStoreInstanceId, context.pageContext);
        this._store.addChangedListener(this._onStoreChange);
        this.state = this._store.getState();
    }

    public componentWillUnmount(): void {
        this._store.removeChangedListener(this._onStoreChange);
    }

    public render(): React.ReactNode {
        switch (this.state.credentialType) {
            case ArmCredentialsType.Secret:
                return <ManualSecretComponent />;
            case ArmCredentialsType.Wif:
                return <ManualWIFComponent />;
            default:
                return null;
        }
    }

    private _onStoreChange = (): void => {
        const state = this._store.getState();
        this.setState(state);
    }
}
